// ArticleCard.tsx
import React from "react";
import Tag from "./Tag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";

interface ArticleCardProps {
  tagLabel?: string;
  title: string;
  intro: string;
  date: string;
  readingTime: string;
  thumbnail?: string;
  onClick?: () => void;
}

const ArticleCard: React.FC<ArticleCardProps> = ({
  tagLabel,
  title,
  intro,
  date,
  readingTime,
  thumbnail,
  onClick,
}) => {
  return (
    <div
      className="ArticleCard w-[378.67px] h-full flex-col justify-start items-start gap-6 inline-flex cursor-pointer"
      onClick={onClick}
    >
      {/* Thumbnail Section */}
      <div className="Thumb self-stretch h-60 p-3 rounded-sm justify-start items-start gap-2.5 inline-flex bg-gray-100 relative">
        {thumbnail ? (
          <img
            src={thumbnail}
            alt={title}
            className="absolute inset-0 w-full h-full object-cover rounded-sm"
          />
        ) : (
          <div className="w-full h-full bg-gray-200 rounded-sm"></div>
        )}
        {/* Conditionally render the Tag */}
        {tagLabel && (
          <div className="absolute top-3 left-3">
            <Tag label={tagLabel} />
          </div>
        )}
      </div>

      {/* Text Section */}
      <div className="Text self-stretch pr-4 flex-col justify-start items-start gap-3 flex">
        <div className="Title self-stretch text-[#04262b] text-lg font-semibold font-['Manrope'] leading-[27px] tracking-tight">
          {title}
        </div>
        <div className="Intro self-stretch text-[#454846] text-sm font-medium font-['Manrope'] leading-normal tracking-tight">
          {intro}
        </div>
      </div>

      {/* Caption Section */}
      <div className="Caption justify-center items-center gap-2 inline-flex">
        <div className="Date text-[#454846] text-sm font-semibold font-['Manrope'] leading-tight tracking-tight">
          {date}
        </div>
        <div className="Dash w-3 h-px bg-[#454846]"></div>
        <FontAwesomeIcon icon={faClock} className="text-[#454846] text-sm" />
        <div className="ReadingTime text-[#454846] text-sm font-semibold font-['Manrope'] leading-tight tracking-tight">
          {readingTime}
        </div>
      </div>
    </div>
  );
};

export default ArticleCard;
